import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext } from '@tanstack/react-router';

import { AppShell } from '@/components/layout/app-shell';
import {
  RouteErrorBoundary,
  RouteNotFound,
} from '@/components/route-error-boundary';

/**
 * What every route can reach through `context`.
 *
 * The `QueryClient` is threaded through the router rather than imported so a
 * route `loader` — which runs outside React and therefore cannot call
 * `useQueryClient()` — can still prefetch into the same cache the components
 * read from. Later sections rely on this for the viewer's parallel loads.
 */
export interface RouterContext {
  queryClient: QueryClient;
}

/**
 * The root route: the application shell, plus the error and not-found
 * boundaries every descendant inherits.
 */
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: AppShell,
  errorComponent: RouteErrorBoundary,
  notFoundComponent: RouteNotFound,
});
